import React from "react";

const DownArrowIcon = () => {
  return (
    <svg
      width="20"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7359 0.833786C11.5667 0.66589 11.3373 0.57157 11.098 0.57157C10.8588 0.57157 10.6294 0.66589 10.4602 0.833786L5.99455 5.26695L1.52889 0.833786C1.35874 0.670647 1.13086 0.580377 0.894314 0.582417C0.657773 0.584457 0.431501 0.678645 0.264234 0.844695C0.0969673 1.01074 0.00209004 1.23537 3.48532e-05 1.47019C-0.00202034 1.70501 0.0889115 1.93124 0.253246 2.10015L5.35673 7.16649C5.52591 7.33439 5.75533 7.42871 5.99455 7.42871C6.23377 7.42871 6.4632 7.33439 6.63238 7.16649L11.7359 2.10015C11.905 1.9322 12 1.70445 12 1.46697C12 1.22949 11.905 1.00173 11.7359 0.833786Z"
        fill="#666666"
      />
    </svg>
  );
};

export default DownArrowIcon;
